import React from "react";

const LegalLink = ({label}) => {
  return (
    <a href={"https://cloud.zitelia.com/index.php/s/9abWwzxTZd6zwkf"} target="_blank" rel="noreferrer noopener">{label}</a>
  )
};

export default LegalLink;
